/**
 * Default placeholder template for new chat templates
 * This template provides a starting point when creating a new template
 */
export const placeholderTemplate = {
    "title": `Create a Job Description`,
    "description": "",
    "initialMessageText": `Hey there! Let's get started on writing a job description. Tell me a bit about the role and I'll create a first draft we can collaborate on. Feel free to attach any existing job descriptions you have that you'd like me to reference as an example."`,
    "messageComponents": [],
    "hasFileUpload": false,
    "fileUploadMessage": "Choose file or drag files here to include files with the message.",
    "includedFiles": [],
    "userAddedFiles": [],
    "tags": [],
    "customText": null,
    "data": [],
};

/**
 * Creates a fully configured placeholder template with model and settings
 * @param {Object} models - Available models
 * @param {Array} settings - Model parameters/settings
 * @param {Object} defaultAssistant - Default assistant configuration
 * @returns {Object} Configured placeholder template
 */
export const createConfiguredPlaceholderTemplate = (models, settings, defaultAssistant) => {
    return {
        ...placeholderTemplate,
        modelId: models?.find((model) => model.isDefaultTextModel)?.engine,
        modelParameters: [...settings],
        customText: defaultAssistant.systemMessage,
    };
};
